import script from "./BlogDetailView.vue?vue&type=script&setup=true&lang=js"
export * from "./BlogDetailView.vue?vue&type=script&setup=true&lang=js"

import "./BlogDetailView.vue?vue&type=style&index=0&id=103c0e34&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-103c0e34"]])

export default __exports__